<div class="oauth-callback">
  <h1>Lipp Portal</h1>
  <p>{{ message }}</p>
</div>
